import React, { PureComponent } from 'react';
import classnames from 'classnames';
import ChoroplethMapWidget from '~/core/scripts/widgets/ChoroplethMapWidget';

const basemapAttribution = 'Karte: <a href="https://www.maptiler.com/license/maps/" target="_blank">© MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a>';

class IncomeMap extends PureComponent {
  constructor() {
    super();

    this.state = {
      isAlt: false
    }
  }

  handleDefaultMode() {
    this.setState({ isAlt: false });
  }

  handleAltMode() {
    this.setState({ isAlt: true });
  }

  render() {
    const { isAlt } = this.state;

    const DefaultButtonClasses = classnames('btn', { active: !isAlt });
    const AltButtonClasses = classnames('btn', { active: isAlt });

    const valueKey = isAlt ? 'change' : 'income';
    const valueKeyAlt = isAlt ? 'income' : 'change';

    const colorSteps = isAlt ? 
    [      
      [-4, '#f9c19f'],
      [0, '#e6f8ea'],
      [4, '#a7d8db'],
      [9, '#72b5cb'],
      [14, '#4791b9'],
      [18, '#236da6'],
      [25, '#004992'],
      [43]
    ] :
    [      
      [16200, '#ddf9ff'],
      [19000, '#b2d6fb'],
      [20600, '#8fb3ee'],
      [22000, '#778fd9'],
      [23000, '#6a6bbe'],
      [25000, '#64469c'],
      [29000, '#601777'],
      [35000]
    ];
    const legendMinLabel = isAlt ? '-4 %' : '16.200 €';
    const legendMaxLabel = isAlt ? '+43 %' : '35.000 €';

    const wrapperClasses = isAlt ? 'income-map-wrapper isAlt' : 'income-map-wrapper';

    return (
      <div className={wrapperClasses}>

        <div className="income-map-controls">
          <div className="btn-group horizontal">
            <button onClick={() => this.handleDefaultMode()} className={DefaultButtonClasses}>Einkommen <em>(2016)</em></button>
            <button onClick={() => this.handleAltMode()} className={AltButtonClasses}>Entwicklung <em>(seit 2000)</em></button>
          </div>
        </div>

        <ChoroplethMapWidget
          isAlt={isAlt}
          minZoom={3}
          maxZoom={10}
          choroplethSource="data/income.topo.json"
          overlaySource="data/income.topo.json"
          overlayDissolveKey="bundesland"
          showBasemap
          basemapUrl="https://maps.tilehosting.com/c/a0a037d7-f288-42a8-88cf-666cf06cee7a/styles/genderpaygapmap_2019/{z}/{x}/{y}@2x.png?key=68ErAz6zqgdV9jEjhpuz"
          basemapAttribution={basemapAttribution}
          showGeocoder
          valueKey={valueKey}
          valueKeyAlt={valueKeyAlt}
          colorSteps={colorSteps}
          showLegend
          legendMinLabel={legendMinLabel}
          legendMaxLabel={legendMaxLabel}
          showLabels
          labelPreset="germanStates"
          customLabels={[]}
          searchPresets={[{ name: 'Hamburg', locationId: 'NT_XIIiPCDkZjsN9RlMdvhL9C' }, { name: 'Berlin', locationId: 'NT_DKX2wfaWICS7JyfHmCOJhB' }, { name: 'Köln', locationId: 'NT_BXqF2OWXjw0Df08cTCVyUB' }]}
          searchPresetsTitle="Zum Beispiel:"
          smoothFactor={1}
        />

      </div>
    );
  }
}

export default IncomeMap;